export default __webpack_public_path__ + "static/media/404.849f8a7d.jpg";